module.exports = __webpack_public_path__ + "static/img/complain.2e7d061.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/complain.png
// module id = SXMQ
// module chunks = 0